import React, { Component } from "react";
import { Button, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";

import ValueInc from "./dropdown/components/ValueInc";
import LineBar from "../asset_components/lineBar";
import ToolTipA from "../commonComponents/ToolTipA";
import LoadingLearning from "../commonComponents/LoadingLearn";

import resetIcon from "../../assets/icons/refresh.svg";
import play from "../../assets/icons/play.svg";

class Learning extends Component {
  defaultEpochs = 50;
  defaultBatchSize = 16;
  defaultLearningRate = 0.001;
  constructor(props) {
    super(props);
    this.state = {
      epochs: 50,
      batchSize: 16,
      lerarningRate: 0.001,
    };
    this.child1 = React.createRef();
    this.child2 = React.createRef();
    this.child3 = React.createRef();
  }

  trainModel = () => {
    this.props.changeConvertSignal(
      true,
      this.state.epochs,
      this.state.batchSize,
      this.state.lerarningRate
    );
  };

  resetValues = () => {
    this.child1.current.resetValues();
    this.child2.current.resetValues();
    this.child3.current.resetValues();
  };

  handleEpochsValues = (val) => {
    this.setState({
      epochs: val,
    });
  };

  handleBtSizeValues = (val) => {
    this.setState({
      batchSize: val,
    });
  };

  handleLrValues = (val) => {
    this.setState({
      lerarningRate: val,
    });
  };

  render() {
    let mTop;
    if (this.props.deviceType === "DESKTOP") {
      mTop = "90px";
    } else {
      mTop = "22px";
      //tipMargin
    }
    return (
      <div
        style={{
          marginTop: mTop,
          borderWidth: "1px",
          borderStyle: "solid",
          background: "#2E3A53",
          width: "295px",
          boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "9px",
        }}
      >
        <Row>
          <div
            style={{
              marginLeft: "32px",
              marginTop: "13px",
              color: "#C2C0BD",
              width: "69px",
              fontSize: "16px",
              height: "42px",
            }}
          >
            Learning
          </div>
        </Row>
        <Row>
          <div style={{ marginTop: "13px", textAlign: "center" }}>
            <LoadingLearning
              modelCall={this.trainModel.bind(this)}
              bttnStatus={this.props.bttnStatus}
              epochs={this.state.epochs}
            />
          </div>
        </Row>
        <br />
        <div>
          <LineBar />
        </div>

        <Row>
          <div
            style={{ marginLeft: "37px", marginTop: "23px", color: "#C2C0BD" }}
          >
            <Col xs={4}>
              <div
                style={{
                  fontFamily: " Helvetica",
                  fontWeight: "normal",
                  fontSize: "12px",
                  paddingTop: "7px",
                }}
              >
                Epochs
              </div>
            </Col>
            <Col xs={4}>
              <div>
                <ValueInc
                  width={"50px"}
                  incBy={25}
                  default={this.defaultEpochs}
                  decimal={0}
                  min={0}
                  ref={this.child1}
                  func1={this.handleEpochsValues}
                />
              </div>
            </Col>
            <Col xs={3}>
              <div style={{ marginTop: "3px" }}>
                <Button
                  style={{
                    padding: "0px",
                    border: "0px",
                    backgroundColor: "#2E3A53",
                    outline: "none",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ToolTipA content={"Loren Ipsum"} />
                </Button>
              </div>
            </Col>
          </div>
        </Row>
        <div>
          <LineBar />
        </div>

        <Row>
          <div
            style={{ marginLeft: "37px", marginTop: "23px", color: "#C2C0BD" }}
          >
            <Col xs={4}>
              <div
                style={{
                  fontFamily: " Helvetica",
                  fontWeight: "normal",
                  fontSize: "12px",
                  paddingTop: "7px",
                }}
              >
                Batch Size
              </div>
            </Col>
            <Col xs={4}>
              <div>
                <ValueInc
                  width={"50px"}
                  incBy={10}
                  default={this.defaultBatchSize}
                  decimal={0}
                  min={0}
                  ref={this.child2}
                  func1={this.handleBtSizeValues}
                />
              </div>
            </Col>
            <Col xs={2}>
              <div style={{ marginTop: "3px" }}>
                <Button
                  style={{
                    padding: "0px",
                    border: "0px",
                    backgroundColor: "#2E3A53",
                    outline: "none",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ToolTipA content={"Loren Ipsum"} />
                </Button>
              </div>
            </Col>
          </div>
        </Row>
        <div>
          <LineBar />
        </div>

        <Row>
          <div
            style={{
              marginLeft: "37px",
              marginTop: "23px",
              marginRight: "30px",
              color: "#C2C0BD",
            }}
          >
            <Col xs={5}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontFamily: " Helvetica",
                  fontWeight: "normal",
                  fontSize: "12px",
                  paddingTop: "7px",
                }}
              >
                Learning Rate
              </div>
            </Col>
            <Col xs={4} style={{ paddingLeft: "0px", paddingRight: "3px" }}>
              <div>
                <ValueInc
                  width={"65px"}
                  incBy={0.001}
                  default={this.defaultLearningRate}
                  decimal={3}
                  min={0.001}
                  ref={this.child3}
                  func1={this.handleLrValues}
                />
              </div>
            </Col>
            <Col xs={2} style={{ paddingLeft: "13px" }}>
              <div style={{ marginTop: "3px" }}>
                <Button
                  style={{
                    padding: "0px",
                    border: "0px",
                    backgroundColor: "#2E3A53",
                    outline: "none",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ToolTipA content={"Loren Ipsum"} />
                </Button>
              </div>
            </Col>
          </div>
        </Row>
        <div>
          <LineBar />
        </div>
        <Row>
          <div
            style={{
              marginTop: "13px",
              textAlign: "center",
              color: "#C2C0BD",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Button
              style={{
                padding: "0px",
                border: "0px",
                backgroundColor: "#2E3A53",
                marginRight: "10px",
                outline: "none",
                color: " #C2C0BD",
                fontFamily: "Helvetica",
                fontWeight: "normal",
                fontSize: "12px",
              }}
              onClick={this.resetValues}
            >
              <img src={resetIcon} style={{ marginRight: "13px" }} />
              Reset Defaults
            </Button>
          </div>
        </Row>
        <div>
          <LineBar />
        </div>
        <Row>
          <div
            style={{
              marginTop: "13px",
              textAlign: "center",
              color: "#C2C0BD",
              justifyContent: "center",
              display: "flex",
              marginBottom: "30px",
            }}
          >
            <Button
              style={{
                padding: "0px",
                border: "0px",
                backgroundColor: "#2E3A53",
                marginRight: "10px",
                outline: "none",
                color: " #C2C0BD",
                fontFamily: "Helvetica",
                fontWeight: "normal",
                fontSize: "12px",
              }}
            >
              <img src={play} style={{ marginRight: "13px" }} />
              Under the Hood
            </Button>
          </div>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    //CALL TO CONVERT IMG TO TENSOR INSIDE INDIVIDUAL CLASS
    changeConvertSignal: (status, epochs, batchSize, lerarningRate) => {
      dispatch({
        type: "UPDATE_SIGNAL",
        signal: status,
        epochs: epochs,
        batchSize: batchSize,
        lerarningRate: lerarningRate,
      });
    },
  };
};

export default connect(null, mapDispatchToProps)(Learning);
